// apps/web/src/useStore.js
// Migrated from src/react/useStore.js

import { useSyncExternalStore } from "react";
import {
  getState,
  getStateRevision,
  subscribe,
  setState,
} from "@tennis-matches/core/store";

let cachedRevision = -1;
let cachedState = null;

function getSnapshot() {
  const revision = getStateRevision();
  if (revision !== cachedRevision) {
    cachedRevision = revision;
    cachedState = getState();
  }
  return cachedState;
}

export function useAppState() {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}

export function useSetState() {
  return setState;
}
